import styled from 'styled-components';
import { TitleMainStyle, Title } from '../../components/titles';
import { FontSize32, FontSize18, FontSize14, FontFamilyMedium, FontSize10, FontFamilyRegular } from '../../components/fonts';
import { MarginRight20, MarginBottom20, MarginTop20, MarginTop10 } from '../../components/margins';
import { TextBlock, TextAlignCenter } from '../../components/text';
import { InputGradient, ButtonGradient } from '../../components/Buttons';
import { ButtonIconWrapper } from '../../components/Buttons/style';

export const ToActivateTitle = styled.h1`
    ${TitleMainStyle};
    font-size: 25px;
    text-align: left;
`;
export const ToActivateSubTitle = styled.span`
    ${FontFamilyMedium};
`;
export const CardsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    padding: 0 20px 20px 20px;
`;

export const CardContainer = styled.div`
    @media (min-width: 400px) {
        &:not(:last-child) {
            margin-right: 10px;
        }
    }
    ${MarginTop20};
    width: 100%;
    max-width: 340px;
`;

export const TitlePersonalData = styled(Title)`
    ${MarginBottom20};
`;

export const SubtitlePersonalData = styled(TextBlock)`
    ${FontSize18};
    ${MarginTop20};
    margin-bottom: 40px;
    text-align: left;
`;

export const FormContainer = styled.form`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
`;

export const ButtonIconWrapperNoMargin = styled(ButtonIconWrapper)`
    margin: 0;
`;

export const AccordionContainer = styled.div`
    margin-top: 60px;
    width: 100%;
`;